import React, { createContext, useContext, useState, useEffect } from "react";
import { verifyTokenApi } from "../services/api"; // Optional (if you have token verify API)

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔥 Check login on app load
  useEffect(() => {
    const initializeAuth = async () => {
      const token = localStorage.getItem("token");
      const userType = localStorage.getItem("userType");

      if (!token) {
        setLoading(false);
        return;
      }

      try {
        // Optional: verify token with backend
        // const res = await verifyTokenApi();
        // setUser(res.data.user);

        // Simple version (no verify)
        setUser({
          token,
          role: userType || "student",
        });
      } catch (error) {
        logout();
      } finally {
        setLoading(false);
      }
    };

    initializeAuth();
  }, []);

  // 🔥 LOGIN FUNCTION
  const login = (token, userData) => {
    localStorage.setItem("token", token);
    localStorage.setItem("userType", userData?.role || "student");

    setUser({
      token,
      role: userData?.role || "student",
    });
  };

  // 🔥 LOGOUT FUNCTION
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userType");
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated: !!user,
        role: user?.role,
        login,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Custom Hook
export const useAuth = () => {
  return useContext(AuthContext);
};
